<template>
  <div class="insights_primary">
    <v-overlay
      v-if="loadingInsights || loadingWorkbench"
      :value="showOverlay"
      absolute
      light
      class="insightsOverlay"
    >
      <v-container>
        <v-row
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-h5 text-center"
            cols="12"
          >
            {{ overlayMessage }}
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              indeterminate
              height="8"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
    <div
      v-if="insightUpdateError"
      class="insightsMessage text-h5 red--text"
      style="margin-top: 10vh"
    >
      {{ overlayMessage }}
    </div>
    <div
      v-else-if="initialOverlay"
      class="insightsMessage text-h4"
      style="margin-top: 20vh"
    >
      {{ overlayMessage }}
    </div>
    <div
      v-else
      class="pa-6"
      :style="loadingInsights ? 'opacity: 0.1' : ''"
      id="primaryInsightCardsContainer"
    >
      <div class="insightsCard mb-4">
        <v-card
          elevation="2"
          name="householdIdCards"
          outlined
          v-if="isHouseholdDataAvailable"
        >
          <v-card-title>
            <v-spacer />
            <div>
              <div class="insightsCardTitle text-subtitle-1">household id</div>
              <div class="pl-8">
                <v-img
                  :src="houseIcon"
                  width="2em"
                >
                </v-img>
              </div>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card
            class="justify-center d-flex flex-wrap ml-10 mr-10 mb-2"
            flat
            tile
          >
            <v-card
              v-for="data in householdCardData"
              :key="data.idType"
              flat
              class="ml-6 mr-6"
            >
              <div class="text-body-1 text-center">
                {{ data.idType }}
              </div>
              <div class="text-h5 font-weight-bold text-center">
                {{ formattedCount(data.count) }}
              </div>
            </v-card>
          </v-card>
        </v-card>
      </div>
      <div class="insightsCard">
        <v-card
          v-if="isDeviceDataAvailable"
          elevation="2"
          name="deviceIdCards"
          outlined
          class="deviceIdCards"
        >
          <v-card-title>
            <v-spacer />
            <div class="text-center">
              <div class="insightsCardTitle text-subtitle-1">device id</div>
              <div>
                <v-img
                  :src="deviceIcon"
                  width="4.5em"
                >
                </v-img>
              </div>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card
            :class="deviceIdCardsClass"
            flat
          >
            <v-card
              v-for="data in deviceCardData"
              :key="data.idType"
              flat
              class="deviceIdCountCard ml-lg-6 mr-lg-6 mb-2"
            >
              <div class="text-uppercase text-body-1 text-center">
                {{ data.idType }}
              </div>
              <div class="text-h5 font-weight-bold text-center">
                {{ formattedCount(data.count) }}
              </div>
            </v-card>
          </v-card>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  import ScrollPanel from '@/components/common/scrollPanel'
  import { newSmallNumber } from '@/helpers'
  import DeviceIcon from '@/assets/Xandr/devicesIcon.png'
  import HouseHoldIcon from '@/assets/Xandr/householdIcon.png'
  import PeopleIcon from '@/assets/Xandr/peopleIcon.png'
  import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

  // TODO
  // 3. figure out font situation https://creativemarket.com/webhance/3377327-Maverick-Modern-Webfont

  export default {
    components: {
      ScrollPanel,
    },
    props: {
      loadingInsights: {
        type: Boolean,
      },
      loadingWorkbench: {
        type: Boolean,
        default: false,
      },
      primaryInsights: {
        type: Object,
        default: () => {
          return {
            queryId: 'xxxx-xxxx-xxxx',
            counts: {},
          }
        },
      },
    },
    data() {
      return {
        houseIcon: HouseHoldIcon,
        peopleIcon: PeopleIcon,
        deviceIcon: DeviceIcon,
        deviceCardData: [],
        householdCardData: [],
        insights: {},
        overlayMessage: '',
        peopleCardData: [],
        initialOverlay: true,
        insightUpdateError: false,
        loopOverlayMessageInterval: null,
        loadingMessages: [
          'Computing the secret to life, the universe, and everything.',
          "Let's take a mindfulness minute...",
          "Don't break your screen yet!",
          "We're making you a cookie.",
          'Spinning the wheel of fortune...',
          'Loading the enchanted bunny...',
          'Computing chance of success',
          'I feel like I am supposed to be loading something. . .',
          "We're testing your patience",
          'Swapping time and space...',
          'Looking for exact change',
          'Granting wishes...',
          'Time flies when you are having fun.',
          'How did you get here?',
          'Please hold on as we reheat our coffee',
          'Ordering 1s and 0s...',
          "Help, I'm trapped in a loader!",
          'Pushing pixels...',
          'How about this weather, eh?',
          'Time flies like an arrow; fruit flies like a banana',
          'Doing the heavy lifting',
          "We're working very Hard .... Really",
          "No, I'm awake. I was just resting my eyes.",
          'One mississippi, two mississippi...',
          'TODO: Insert elevator music',
          'Brewing potions with Snape...',
          'Waiting for the Hogwarts Express at platform 9¾...',
          'Playing a quick game of Quidditch...',
          'Consulting the Sorting Hat...',
          'Summoning a Patronus to chase the Dementors away...',
          'Casting Lumos to light up your screen...',
          'Looking for the Golden Snitch...',
          'Sending owls with your message...',
          'Conjuring some Butterbeer in the Three Broomsticks...',
          'Tuning the strings on the Weird Sisters’ guitars...',
          'Trying to find the Room of Requirement...',
          'Fetching ingredients for a Felix Felicis...',
          'Asking Nearly Headless Nick for directions...',
          'Perfecting our swish and flick for Wingardium Leviosa...',
          'Checking in with Dumbledore’s Army...',
          'Sneaking through the Forbidden Forest...',
          'Reading tea leaves with Professor Trelawney...',
          'Visiting Gringotts for some extra gold...',
          'Charging up with a Gillyweed snack...',
          'Waiting for Madam Pomfrey in the infirmary...',
          'Crafting wands at Ollivanders...',
          'Fetching a book from the Restricted Section of the library...',
          'Gathering the house elves for a kitchen raid...',
          'Negotiating with Peeves for a smoother site loading...',
          'Summoning dragons…',
          'Hiring minions to speed things up...',
          'Warming up the hamsters...',
          'Feel free to daydream...',
          'Knitting socks for kittens...',
          'Digging the garden of data...',
          'Cranking up the awesome oscillator...',
          "Herding cats, it's harder than it looks...",
          'Looking under the couch for the remote...',
          'Reticulating splines, whatever that means...',
          'Trying to feel quantum entangled...',
          'Counting infinity, just give us a sec...',
          'Whispering to clouds for better weather...',
          'Polishing the moon boots...',
          'Rolling the magic dice...',
          'Brewing a fresh pot of internet...',
          'Procrastinating on loading procrastination message...',
          'Deciding what to eat for lunch...',
          'Charging our psychic powers...',
          "Sharpening our unicorn's horn...",
          'Dusting off the cobwebs in the server room...',
          'Unfolding origami bytes...',
          'Playing rock-paper-scissors to determine load order...',
          'Holding a purring contest with the neighborhood cats...',
          'Fetching the laser pointer...',
          'Distracting the cats with shiny objects...',
          'Building a cardboard fortress...',
          'Knitting tiny cat sweaters...',
          'Deciding on the purrfect nap spot...',
          'Opening a fresh can of tuna...',
          'Paw-painting the masterpieces...',
          'Searching for the lost toy under the couch...',
          'Catching the dot. Finally almost there...',
          'Unraveling the mysteries of the red dot...',
          'Recording purrs for stress relief...',
          'Negotiating with the cat for more keyboard space...',
          'Calling on Batman to secure the Batcave...',
          'Assembling the Justice League...',
          "Charging the Green Lantern's power ring...",
          'Tuning the Lasso of Truth...',
          'Synchronizing the multiverse...',
          'Tracking down The Flash to speed things up...',
          'Designing new suits at Wayne Enterprises...',
          "Fetching water from Aquaman's kingdom...",
          "Aligning the planets with Superman's help...",
          'Decrypting codes with Cyborg...',
          "Harley Quinn's causing a little mischief...",
          "Activating Wonder Woman's Amazonian strength...",
          "Testing Joker's latest prank gadgets...",
          'Calibrating the Bat-Signal...',
          'Ironing capes in the Batcave...',
          'Gathering Martian Manhunter from the shadows...',
          'Consulting with Alfred Pennyworth for advice...',
          'Polishing the Batmobile, almost ready for a spin...',
          'Preparing Poison Ivy’s botanical specimens...',
          "Checking durability of Black Canary's sonic devices...",
          'Crafting arrows with Green Arrow...',
          'Refueling the Invisible Jet for Wonder Woman...',
        ],
      }
    },
    computed: {
      queryErrored() {
        return this.$store.state.workbench.xandr_workbench.queryErroredOut
      },
      showOverlay() {
        return this.queryErrored || this.loadingInsights || this.initialOverlay || this.loadingWorkbench
      },
      isHouseholdDataAvailable() {
        return Object.keys(this.householdCardData).length > 0
      },
      isDeviceDataAvailable() {
        return this.deviceCardData.length > 0
      },
      newWorkbenchTarget() {
        return this.$store.getters['workbench/newWorkbenchTarget']
      },
      isUsingMockData() {
        return this.$store.getters['workbench/xandrUseMockData']
      },
      primaryInsightsFilter() {
        return this.$store.getters.primaryInsightsFilter
      },
      deviceIdCardsClass() {
        return this.deviceCardData.length < 3
          ? 'justify-center d-flex flex-wrap mb-2'
          : 'justify-start d-flex flex-wrap mb-2'
      },
    },
    mounted() {
      // might do it on created
      this.insights = this.primaryInsights

      const unWatch = this.$watch(
        // watch only once until newWorkbenchTarget is available
        () => this.newWorkbenchTarget,
        wbTarget => {
          if (wbTarget) {
            if (wbTarget.activation_status === ACTIVATION_STATUS.DRAFT) {
              if (this.insights && this.insights.counts) {
                this.insights.counts.isUsingMockData = this.$store.getters['workbench/xandrUseMockData']
              }
            } else if (
              wbTarget.xandr_data &&
              wbTarget.xandr_data.query &&
              wbTarget.xandr_data.query.counts.isUsingMockData
            ) {
              // Existing Insights is using mock data
              if (this.insights && this.insights.counts) {
                this.insights.counts.isUsingMockData = true
              }
            } else {
              if (this.insights.counts.hasOwnProperty('isUsingMockData')) {
                delete this.insights.counts.isUsingMockData
              }
            }
            unWatch()
          }
        },
      )
      this.draw()
      this.showInitialOverlayMessage()
    },
    methods: {
      draw() {
        if (this.insights.counts) {
          const granularDevices = Array.isArray(this.insights.counts.granularDevices)
            ? this.insights.counts.granularDevices
            : null
          this.resetCardData()
          if (granularDevices) {
            this.findHouseholdData(granularDevices)
            this.findDeviceData(granularDevices)
          }
        }
      },
      findDeviceData(granularDevices) {
        let deviceIdsFilter = this.primaryInsightsFilter.deviceIds
        this.deviceCardData = granularDevices
          .filter(device => {
            if (deviceIdsFilter.show.length > 0) {
              return deviceIdsFilter.show.includes(device.idType)
            } else if (deviceIdsFilter.hide.length > 0) {
              return !deviceIdsFilter.hide.includes(device.idType)
            }
            return true
          })
          .map(device => {
            if (typeof deviceIdsFilter.rename === 'object' && deviceIdsFilter.rename.hasOwnProperty(device.idType)) {
              return { ...device, idType: deviceIdsFilter.rename[device.idType] }
            } else {
              return device
            }
          })
      },
      findHouseholdData(granularDevices) {
        let householdIdsFilter = this.primaryInsightsFilter.houseHoldIds
        this.householdCardData = granularDevices
          .filter(device => {
            if (householdIdsFilter.show.length > 0) {
              return householdIdsFilter.show.includes(device.idType)
            } else if (householdIdsFilter.hide.length > 0) {
              return !householdIdsFilter.hide.includes(device.idType)
            }
            return true
          })
          .map(device => {
            if (
              typeof householdIdsFilter.rename === 'object' &&
              householdIdsFilter.rename.hasOwnProperty(device.idType)
            ) {
              return { ...device, idType: householdIdsFilter.rename[device.idType] }
            } else {
              return device
            }
          })
      },
      formattedCount(count, idType) {
        if (!count && count !== 0) {
          return 'N/A'
        }
        const formattedCount = newSmallNumber(count, 1)
        return formattedCount
      },
      showInitialOverlayMessage() {
        this.insightUpdateError = false
        this.overlayMessage =
          'Stats will be available when you have \n added at least one target attribute \n and select Update Insights.'
      },
      showLoadingOverlayMessage() {
        this.insightUpdateError = false
        this.overlayMessage =
          'Your information is loading, please stand by while we retrieve your target attribute stats...'
        this.loopOverlayMessageInterval = setInterval(() => {
          this.overlayMessage = this.loadingMessages[Math.floor(Math.random() * this.loadingMessages.length)]
        }, 10000)
      },
      showLoadingWorkbenchOverlayMessage() {
        this.insightUpdateError = false
        this.overlayMessage = 'Updating segment and loading workbench...'
        this.loopOverlayMessageInterval = setInterval(() => {
          this.overlayMessage = this.loadingMessages[Math.floor(Math.random() * this.loadingMessages.length)]
        }, 10000)
      },
      showLoadErrMessage() {
        this.insightUpdateError = true
        this.overlayMessage = `Insights were unable to be updated.`
      },
      resetCardData() {
        this.householdCardData = []
        this.deviceCardData = []
      },
    },
    watch: {
      loadingInsights() {
        // TODO this should be computed and not on a watch
        if (this.loadingInsights) {
          if (this.loadingInsights) {
            this.initialOverlay = false
            this.showLoadingOverlayMessage()
          } else {
            this.showInitialOverlayMessage()
          }
        } else {
          clearInterval(this.loopOverlayMessageInterval)
        }
      },
      loadingWorkbench() {
        if (this.loadingWorkbench) {
          this.initialOverlay = false
          this.showLoadingWorkbenchOverlayMessage()
        } else {
          clearInterval(this.loopOverlayMessageInterval)
        }
      },
      primaryInsights() {
        this.initialOverlay = false
        this.insights = this.primaryInsights
        this.draw()
      },
      isUsingMockData() {
        if (this.isUsingMockData) {
          this.insights.counts.isUsingMockData = true
        } else {
          if (this.insights.counts.hasOwnProperty('isUsingMockData')) {
            delete this.insights.counts.isUsingMockData
          }
        }
      },
      queryErrored() {
        if (this.queryErrored) {
          this.showLoadErrMessage()
        }
      },
    },
  }
</script>

<style lang="scss">
  $white: white;
  $black: #000;
  $lightGray: #bebec5; // for divider line
  $grey: grey;
  $longWidth: 600px;
  $widthControl: 79vh;

  .insights_primary {
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 98%;
  }
  .insightsCard {
    display: flex;
    justify-content: center;
  }
  .insightsOverlay {
    opacity: '0.6';
    z-index: '5';
    width: '75%';
    height: '75%';
  }
  .insightsMessage {
    text-align: center !important;
    padding: 0em 1.5em;
  }
  .insightsCardTitle {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold !important;
  }
  .deviceIdCards {
    min-width: 400px;
  }
  .deviceIdCountCard {
    padding: 7px;
    width: 25%;
  }
</style>



// WEBPACK FOOTER //
// primary.vue?3b0b6ba8